import { Box } from "theme-ui";

export default function CheckmarkCircleIcon(props) {
  return (
    <Box
      as="svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="30" height="30" rx="15" fill="#009CDA" />
      <path
        d="M7.5 17.5L11.5 21.5L23.5 9.5"
        stroke="white"
        strokeLinecap="round"
      />
    </Box>
  );
}
